import { useState } from "react";
import InfoCard from "./components/InfoCard";
import InfoModal from "./components/InfoModal";

interface InfoFlyUpModalProps {
  modalProps: {
    title: string;
    description: string;
    importanceTitle: string;
    unorderedList?: string[];
    textList?: string[];
  };
  cardProps: {
    title: string;
    description: string;
  };
}

export default function InfoFlyUpModal({
  modalProps,
  cardProps,
}: InfoFlyUpModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <InfoCard
        title={cardProps.title}
        description={cardProps.description}
        handleTrigger={() => setIsOpen(true)}
      />
      <InfoModal
        isOpen={isOpen}
        handleClose={handleClose}
        title={modalProps.title}
        description={modalProps.description}
        importanceTitle={modalProps.importanceTitle}
        unorderedList={modalProps.unorderedList}
        textList={modalProps.textList}
      />
    </>
  );
}
